import { sendGoogleEvent } from '@html/_common/utils';
import TourWishlist from '@app/_common/tour-wishlist/wishlist';
import AOClpCarouselSlider from '@atomic/organisms/clp/carousel-slider/scripts';

const SELECTOR_WISHLIST = '.js-ao-common-tours-slider-card__wishlist';
const SELECTOR_SLIDER_SECTION = '.js-ao-clp-tours-slider';
const SELECTOR_SLIDER_ITEM = '.js-ao-clp-tours-slider__item';
const SELECTOR_CARD_LINK = '.js-ao-common-tours-slider-card__anchor';
const EVENT_CATEGORY = 'CLP - Tours Slider';
const SELECTOR_MAIN_TITLE = '.js-ao-clp-tours-slider__title';
const BADGE_SELECTOR = '.ao-common-tours-slider-card__badge-wrapper';

export default function AOClpToursSlider() {
  let $toursSliderSection;
  let isWishlistEnabled;

  let mainTitleText;

  const initTourWishlist = () => {
    const getTitle = ($element) => $element
      .closest('li.js-ao-clp-carousel-slider__column')
      .find('.ao-common-tours-slider-card__title')
      .text()
      ?.trim();

    const getIndex = ($element) => {
      const $associatedCard = $element.parents('.js-ao-clp-carousel-slider__column');
      return $associatedCard && ($associatedCard.index() + 1);
    };

    const googleEventData = { label: mainTitleText, category: EVENT_CATEGORY };

    TourWishlist({
      containerSelector: $toursSliderSection,
      heartSelector: SELECTOR_WISHLIST,
      tooltipSelector: '.js-wishlist-icon__tooltip',
      getIndex,
      getTitle,
      heartActiveClass: 'ao-common-tours-slider-card__wishlist--active',
      googleEventData,
    });
  };

  const cardTracking = () => {
    $toursSliderSection.on('click', SELECTOR_CARD_LINK, (event) => {
      const $target = $(event.currentTarget);
      const targetLink = $target.length && $target.attr('href');
      const targetPosition = $target.length && $target.closest('li').index();

      if (!targetLink) {
        return;
      }

      sendGoogleEvent(
        EVENT_CATEGORY,
        targetLink,
        mainTitleText,
        {
          eventValue: targetPosition + 1,
        },
      );

      /* Remove after MKT A/B - Exclusive tags on Deals Page */
      const dealsPathnames = ['/sales/weekly-deals', '/sales/deals-of-the-week'];
      if (dealsPathnames.includes(window.location.pathname) && $target.find(BADGE_SELECTOR).length) {
        const badgeText = $target.find(BADGE_SELECTOR).text().trim();

        sendGoogleEvent(
          EVENT_CATEGORY,
          `${badgeText} - ${targetLink}`,
          'Exclusive Tags A/B',
        );
      }
    });
  };

  const impessionTracking = () => {
    /* Remove after MKT A/B - Exclusive tags on Deals Page */
    const dealsPathnames = ['/sales/weekly-deals', '/sales/deals-of-the-week'];

    if (
      !$toursSliderSection.find(SELECTOR_SLIDER_ITEM).find(BADGE_SELECTOR).length
      || !dealsPathnames.includes(window.location.pathname)
    ) {
      return;
    }

    const discountsArray = [];
    $toursSliderSection.find(SELECTOR_SLIDER_ITEM).forEach((card) => {
      if (!$(card).find(BADGE_SELECTOR).length) {
        return;
      }

      discountsArray.push($(card).find(BADGE_SELECTOR).text().trim());
    });

    sendGoogleEvent(
      EVENT_CATEGORY,
      discountsArray.join(', '),
      'Impression Tour Slider discounts',
      {
        nonInteraction: true,
      },
    );
  };

  const initiate = () => {
    $toursSliderSection = $(SELECTOR_SLIDER_SECTION);
    const $mainTitle = $toursSliderSection.find(SELECTOR_MAIN_TITLE);
    mainTitleText = $mainTitle.length ? $mainTitle.text().trim() : 'No title';

    isWishlistEnabled = !!$toursSliderSection.find(SELECTOR_WISHLIST).length;
    if (isWishlistEnabled) initTourWishlist();

    cardTracking();
    impessionTracking();
    const $aoClpCarouselSlider = AOClpCarouselSlider();
    $aoClpCarouselSlider.initiate();
  };

  return { initiate };
}
